export const PLATFORM_ROUTE_GROUPS = [
  '/accounts',
  '/actions',
  '/affiliates',
  '/affiliate-recruiting',
  '/affiliations',
  '/contestation',
  '/customers',
  '/collaborators-dashboard',
  '/etickets',
  '/hotleads',
  '/hotlinks/:productId/coproducer',
  '/profile',
  '/integrations',
  '/invites',
  '/messages',
  '/products',
  '/products/manage/:productId',
  '/purchases',
  '/receipts',
  '/reports',
  '/sales-strategy',
  '/smartinstallment',
  '/subscriptions',
  '/shortener',
  '/sales',
  '/tools',
  '/extensions',
  '/payouts',
  '/age-limit'
]

export const APP_ROUTES = {
  cas: {
    login: '/auth/login',
    logout: '/auth/logout',
    renew: '/auth/renew',
    surrogate: '/auth/surrogate'
  },
  root: '/',
  dashboard: '/dashboard',
  dashboardInstagramIntegration: '/dashboard/instagram-integration',
  boostSalesDashboard: {
    chargebackRate: '/reports/chargeback-rate',
    metrics: '/metrics',
    salesDashboards: {
      management: '/sales-management',
      myDashboard: '/sales-management/my-dashboard'
    },
    salesStrategy: '/sales-strategy'
  },
  club: {
    product: '/club/:id'
  },
  membersArea: '/members-area',
  login: '/login',
  signup: '/signup',
  notFound: '/not-found',
  market: '/market*',
  onboarding: '/welcome',
  chat: '/communication*',
  documents: '/documents',
  userAccounts: {
    personal: {
      updatePersonalData: '/accounts/settings/personal/personal-data-update',
      updateDocuments: '/accounts/settings/personal/documents-update'
    }
  },
  blackNovember: '/black-november',
  tools: {
    credentials: '/tools/credentials*',
    driveReport: '/tools/exported-reports*',
    kajabi: '/tools/kajabi2*',
    webhook: '/tools/webhook*',
    automations: '/tools/automations*',
    pixel: '/tools/pixel*',
    audience: '/tools/list/producer/talk_audience',
    integrations: '/tools/manage/integrations*',
    list: {
      list: '/list',
      home: '/tools',
      affiliate: '/tools/list/affiliate*',
      producer: '/tools/list/producer*',
      coproducer: '/tools/list/coproducer*'
    },
    productSelection: '/tools/product-select/:toolId',
    productSelectionGroup: '/tools/product-select/:toolId/:groupName',
    supportConfig: '/tools/whatsapp-management*'
  },
  sales: {
    smartInstallment: '/sales/smart/installment',
    smartRecovery: '/sales/smart/recovery'
  },
  smartinstallmentsDashboard: '/smartinstallments-dashboard*',
  subscription: {
    retentionStrategies: {
      earlyRenewal: {
        details: '/subscription/retention-strategies/early-renewal/:proposalId',
        new: '/subscription/retention-strategies/early-renewal/new'
      },
      strategiesDashboard: '/subscription/retention-strategies'
    },
    subscriptionManagement: '/subscription-management',
    dashboard: '/subscription/dashboard*',
    status: '/subscription-dashboard*',
    deprecatedStatus: '/subscription/status*',
    tools: '/subscription/tools*',
    templateDashboard: '/template-dashboard',
    marketAnalysis: '/market-analysis',
    rfm: '/customers-segmentation-rfm'
  },
  marketplace: {
    analytics: '/marketplace/analytics'
  },
  affiliation: {
    hotlinks: '/hotlinks/:productId',
    changeHistory: '/products/affiliate/change-history'
  },
  products: {
    home: '/products',
    producer: '/products/producer',
    coproduction: '/products/coproduction*',
    affiliations: '/products/affiliations',
    createProduct: ['/products/add*', '/products/bw*', '/products/community/add*']
  },
  wallet: '/wallet*',
  pro: {
    start: '/pro/start',
    professionals: '/pro/professionals',
    professionalDetails: '/pro/professionals/:specialistId',
    partnerships: '/pro/partnerships',
    partnershipsCreate: '/pro/partnerships/create*',
    partnershipRating: '/pro/rating/:partnershipId',
    professionalsList: '/pro/professionals-list',
    aboutService: '/pro/about-service',
    chatRedirect: '/pro/chat-redirect/:partnershipId',
    demands: '/pro/demands',
    bundles: '/pro/professionals/:specialistId/bundles/:bundleId',
    bundleDetails: '/pro/bundles/:bundleId',
    briefing: '/pro/briefing'
  },
  membership: '/membership*',
  password: {
    forgot: '/password/forgot',
    reset: '/password/reset',
    redefine: '/password/redefine'
  }
}

export const BLOCKED_ROUTES = [
  ...Object.values(APP_ROUTES.cas),
  ...Object.values(APP_ROUTES.password),
  APP_ROUTES.login,
  APP_ROUTES.signup,
  APP_ROUTES.notFound,
  '/logout'
]

export const REDIRECT_PATHS = {
  [APP_ROUTES.password
    .forgot]: `${process.env.URL_SSO}/login?service=https://${process.env.APP_HOST}/auth/login&forgot_password=true
    &systemOrigin=app-business-workspace`
}
